import { Configuration } from 'osep-generator-service-client-v1';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { SilentRequest } from '@azure/msal-browser';
import config from '../config';

const basePath = config.basePath;

export const useApiConfig = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const getApiConfig = async () => {
    const silentRequest: SilentRequest = {
      account,
      scopes: [`${config.msalClientId}/.default`, 'offline_access'],
      authority: config.msalAuthority,
    };

    const response = await instance.acquireTokenSilent(silentRequest);
    const accessToken = `Bearer ${response.accessToken}`;

    return new Configuration({
      basePath,
      accessToken,
    });
  };

  return { getApiConfig, axiosInstance: axios };
};
